import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import ContactSection from '../Components/Contact/ContactOne'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function AboutPage() { // renamed component
    return (
        <>
        <Helmet>
                <title>Contact Tickling Tummy | Order Homemade Veg Food in Coimbatore</title>
                <meta name="description" content="Get in touch with Tickling Tummy for homemade vegetarian food orders, daily meal subscriptions, or catering inquiries in Coimbatore. Call or WhatsApp us today!" />
                <meta name="keywords" content="Contact Tickling Tummy, Homemade food Coimbatore, Vegetarian food orders, Veg catering Coimbatore, Daily meal subscriptions, Order veg meals" />
                <link rel="canonical" href="https://ticklingtummy.com/contact" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Contact Tickling Tummy | Order Homemade Veg Food in Coimbatore" />
                <meta property="og:description" content="Get in touch with Tickling Tummy for homemade vegetarian food orders, daily meal subscriptions, or catering inquiries in Coimbatore. Call or WhatsApp us today!" />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg" />
                <meta property="og:url" content="https://ticklingtummy.com/contact" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Contact Tickling Tummy | Order Homemade Veg Food in Coimbatore" />
                <meta name="twitter:description" content="Get in touch with Tickling Tummy for homemade vegetarian food orders, daily meal subscriptions, or catering inquiries in Coimbatore. Call or WhatsApp us today!" />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/tickling-tummy-logo-coimbatore.svg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "Contact Us",
    "item": "https://ticklingtummy.com/contact"
  }
]
        }, null, 2)}
        </script>

            <HeaderOne />
            <ContactSection />
            <Footer />
        </>
    );
}

export default AboutPage;
